import {EntityModel} from "@fedeltapointofsale/data-client";
import {TableLayoutData} from "./table-layout.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class TableLayoutEntityModel extends EntityModel<TableLayoutData> {
    constructor(injector: Injector) {
        super(injector, TableLayoutData);
    }

    override canCreateEntity(): Promise<boolean> {
        return Promise.resolve(false);
    }
}
